import './App.css';
import {HashRouter, BrowserRouter, Routes, Route } from "react-router-dom"

//import NavbarApp from './NavbarApp';
import IndexPricing from './IndexPricing';
import LandingPage from './LandingPage';


function App() {
  return (
    <HashRouter>
    <Routes>
      <Route path='/coffeePulse' element={<LandingPage />}/>
      <Route path='/index.html' element={<IndexPricing />}/>
      <Route path='/' element={<IndexPricing />}/>
    </Routes>
  </HashRouter>

  );
}

export default App;